import React, { useContext } from 'react';

import { Code } from '../Components/CodePreview/Code';
import { RunningReactCode } from '../Components/RunningReactCode';
import { Page } from '../Components/Page';
import { darkModeContext } from '../darkModeContext';

export const FormikExample = () => {
  const dmContext = useContext(darkModeContext);
  const { formikExample, completeExample } = getExamples(
    dmContext && dmContext.value ? true : false,
  );
  return (
    <Page title="Usage with Formik">
      <div>
        <p>
          In order to use the tag-components with{' '}
          <a href="https://jaredpalmer.com/formik/" target="blank">
            Formik
          </a>{' '}
          we need to:
        </p>
        <ul>
          <li>
            Pass a <code>name</code> prop to <code>Tag3Input</code> with the field's name
          </li>
          <li>
            Pass <code>setFieldValue</code> from Formik to <code>Tag3Input</code>
          </li>
          <li>
            Pass the fields value from Formik to <code>Tag3Input</code>
          </li>
        </ul>

        <Code code={completeExample}></Code>
        <div style={{ padding: '20px 0px', borderBottom: '1px solid grey' }}>
          <RunningReactCode
            parentJSX={'Example = () => ' + formikExample}
            jsx={'<Example />'}
            backgroundVisible={false}
            knobs={{}}
            knobValues={{}}
            events={[]}
          />
        </div>
      </div>
    </Page>
  );
};

function getExamples(boo: boolean) {
  const formikExample = `{
    const initialValues = { firstName: '', lastName: '', isStudent: false};
    return (
      <div style={{width: '300px'}}>
        <Formik
          initialValues={initialValues}
          onSubmit={(values) => {
            alert(JSON.stringify(values, null, 2));
          }}
		      validationSchema={Yup.object().shape({
            firstName: Yup.string()
              .min(2, 'Too Short!')
              .required('Required'),
            lastName: Yup.string()
              .min(2, 'Too Short!')
              .required('Required'),
          })}
          render={ ({values, setFieldValue, errors, touched}) => (
            <Form>
              <div>
                <Tag3Label ${boo ? 'colourScheme="dark"' : ''}>First name:</Tag3Label>
                <Tag3Input ${
                  boo ? 'colourScheme="dark" inputStyle={{border: "1px solid white"}}' : ''
                } name="firstName" onInputValueChange={(e) => setFieldValue('firstName', e.detail.value)} value={values.firstName}></Tag3Input>
                {errors.firstName && touched.firstName && (
                <Tag3ValidationAlert ><div>{errors.firstName}</div></Tag3ValidationAlert >
                )}
              </div>
              <div>
                <Tag3Label ${boo ? 'colourScheme="dark"' : ''}>Last name:</Tag3Label>
                <Tag3Input ${
                  boo ? 'colourScheme="dark" inputStyle={{border: "1px solid white"}}' : ''
                } name="lastName" onInputValueChange={(e) => setFieldValue('lastName', e.detail.value)} value={values.lastName}></Tag3Input>
                {errors.lastName && touched.lastName && (
                <Tag3ValidationAlert ><div>{errors.lastName}</div></Tag3ValidationAlert >
                )}
              </div>
              <div>
                <Tag3Checkbox label='Student' textAlign="left" checked={values.isStudent} onCheckboxValueChange={(e) => setFieldValue('isStudent', e.detail.value)}/>
              </div>
              <div style={{marginTop: "20px"}}>
                <Tag3SimpleButton ${
                  boo ? 'colourScheme="dark"' : ''
                } type='submit' accent="midnightblue">Submit</Tag3SimpleButton>
              </div>
            </Form>
          )}
        />
      </div>
    );
  };`;
  const completeExample =
    `import * as React from 'react';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import { Tag3Input, Tag3ValidationAlert, Tag3Label, Tag3Button } from '@tag/tag-components-react-v3';

export default function RHFandTagComponents() ` + formikExample;
  return { formikExample, completeExample };
}
